export class PriorityLoadValues {
    static $inject = ['$translate'];
    constructor($translate) {
        'ngInject';
        this.$translate = $translate;
    }
    async loadUrgencyDegrees() {
        return [
            {
                value: '1000',
                label: await this.$translate('attendance-priority-rules.urgencyDegrees.low'),
            },
            {
                value: '2000',
                label: await this.$translate('attendance-priority-rules.urgencyDegrees.medium'),
            },
            {
                value: '3000',
                label: await this.$translate('attendance-priority-rules.urgencyDegrees.high'),
            },
        ];
    }
    async loadPriorityLabel() {
        return [
            {
                value: '0',
                label: await this.$translate('attendance-priority-rules.priorityLabel.noPriority'),
            },
            {
                value: '1000',
                label: await this.$translate('attendance-priority-rules.priorityLabel.low'),
            },
            {
                value: '2000',
                label: await this.$translate('attendance-priority-rules.priorityLabel.medium'),
            },
            {
                value: '3000',
                label: await this.$translate('attendance-priority-rules.priorityLabel.high'),
            },
            {
                value: '4000',
                label: await this.$translate('attendance-priority-rules.priorityLabel.maximum'),
            },
        ];
    }
}
PriorityLoadValues.$inject = ['$translate'];
